import { render, staticRenderFns } from "./InvitationNotifications.vue?vue&type=template&id=3e63ea83&scoped=true&"
import script from "./InvitationNotifications.vue?vue&type=script&lang=js&"
export * from "./InvitationNotifications.vue?vue&type=script&lang=js&"
import style0 from "./InvitationNotifications.vue?vue&type=style&index=0&id=3e63ea83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e63ea83",
  null
  
)

export default component.exports